module.exports = __webpack_public_path__ + "img/art1-img4.fd31989e.jpeg";